import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, /** @type {EventListener} */ (this.updateInventory));
    this.addEventListener('click', this.#onAssistantClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, /** @type {EventListener} */ (this.updateInventory));
    this.removeEventListener('click', this.#onAssistantClick);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };

  #onAssistantClick = (/** @type {MouseEvent} */ event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.product-inventory__oos-assistant')) return;
    /** @type {any} */ (window).sendAIShoppingAssistantMessage?.({
      trigger: 'pdp',
      message: 'Show me similar items',
      intent: 'SimilarProductEnquiry',
    });
    document.querySelector('.preezie-pdp-loader')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
